/**
 * Creates a getRowClassName function for greying out inactive rows in MUI DataGrid.
 * @param {string} fieldName - The row field to check (e.g., "activated", "active", "canceled")
 * @param {boolean} inverted - If true, field=true means inactive (e.g., "canceled")
 * @returns {function} A getRowClassName callback for DataGrid
 */
export const getInactiveRowClassName = (fieldName, inverted = false) => (params) => {
    const value = params.row[fieldName];
    const isInactive = inverted ? value === true : value === false;
    return isInactive ? "inactive-row" : "";
};

export const inactiveRowStyles = {
    "& .inactive-row": {
        color: "#BDBDBD",
    },
};
